import { CustomerFeatureType } from "../../../types/types";
import { api } from "../api";

const authorization = (token: string) => ({ headers: { Authorization: `Bearer ${token}` } });

export const findCustomerFeatures = async (token: string, customerId: number): Promise<CustomerFeatureType> => {
    const response = await api.get<CustomerFeatureType>(
        `/customer-parameters/customer/${customerId}/features`, authorization(token)
    );
    return response.data;
};

export const findCurrentCustomerFeatures = async (token: string): Promise<CustomerFeatureType> => {
    const response = await api.get<CustomerFeatureType>("/customer-parameters/features", authorization(token));
    return response.data;
};

export const updateCustomerFeatures = async (token: string, features: CustomerFeatureType): Promise<CustomerFeatureType> => {
    const response = await api.put<CustomerFeatureType>(
        `/customer-parameters/customer/${features.customerId}/features`, features, authorization(token)
    );
    return response.data;
};
